import { QueryFunctionContext } from 'react-query';
import { baseQuery } from '../baseQuery';
import { PaginatedApiResponse, TechnicianNote } from 'types';

type getTechnicianNotesParams = {
  technicianId?: string;
  type?: string;
  page?: number;
  per_page?: number;
};

export const getTechnicianNotes = async ({
  queryKey,
}: QueryFunctionContext<[string, getTechnicianNotesParams]>): Promise<PaginatedApiResponse<TechnicianNote[]>> => {
  const [, params] = queryKey;
  const { technicianId, type, page = 1, per_page = 10 } = params;

  const queryParams = new URLSearchParams();
  queryParams.append('page', page.toString());
  queryParams.append('per_page', per_page.toString());
  if (type) queryParams.append('note_type', type);

  const url = `technicians/notes/${technicianId ?? ''}?${queryParams.toString()}`;

  const data: PaginatedApiResponse<TechnicianNote[]> = await baseQuery(url);

  return data;
};
